import cn from 'classnames'
import { ReactNode } from 'react'

import { Button } from 'core-components/library/button'

import styles from './MarketsExpandToggle.module.scss'

interface IMarketsExpandToggleProps {
  isMarketsExpanded: boolean
  title?: ReactNode
  onToggleMarketsExpanded: () => void
}

export const MarketsExpandToggle = ({
  isMarketsExpanded,
  title,
  onToggleMarketsExpanded,
}: IMarketsExpandToggleProps) => (
  <Button
    className={styles.marketsToggle}
    variant="text"
    size="sm"
    icon={cn('kbase', {
      'kbase-expand': !isMarketsExpanded,
      'kbase-compress': isMarketsExpanded,
    })}
    iconPosition="end"
    onClick={(e) => {
      e.stopPropagation()
      onToggleMarketsExpanded()
    }}
  >
    {title}
  </Button>
)

MarketsExpandToggle.displayName = 'MarketsExpandToggle'
